export const toId = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[\W_-]/g, '')

export const slugToId = (value: string) =>
  value.toLowerCase().trim().replace(/^.+-/g, '').replace(/[\W_]/g, '')
